import React from "react";
import "../../styles/ThinkingLoader.css"

const ThinkingLoader = ({ size = 12, color = "#0857c3" }) => {
  return (
    <div className="dots-loader">
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className="dot"
          style={{
            width: size,
            height: size,
            backgroundColor: color,
            animationDelay: `${i * 0.2}s`,
          }}
        />
      ))}
    </div>
  );
};

export default ThinkingLoader;